import React from 'react'
import { useRouter } from 'next/router'

const ShopLink = ({
  locale,
  children,
  ...props
}: {
  locale: string
  children
  [props: string]: unknown
}): JSX.Element => {
  const router = useRouter()
  let href = router.pathname
  const query = {
    ...router.query,
    locale
  }
  Object.keys(router.query).forEach(key => {
    href = href.replace(`[${key}]`, query[key] as string)
  })
  return <a href={href} {...props} >
    {children}
  </a>
}

export default ShopLink
